module.exports = __webpack_public_path__ + "static/media/add_tag_mobile.b8b86427.png";